import {NoOperation} from '@/library/utils';
import {type Directive, type DirectiveBinding, nextTick} from 'vue';

const focus: Directive = {
    mounted(element: HTMLElement, binding: DirectiveBinding)
    {
        if (!binding.hasOwnProperty('value') || 'undefined' === typeof binding.value || binding.value)
        {
            nextTick(() =>
            {
                window.setTimeout(() => element?.focus(), 0);
            }).then(NoOperation);
        }
    },
};

export default focus;